import React, { useContext, useEffect } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import WizardFlow from '@Components/WizardFlow'
import { CLEAR_WORK_DRAFT } from '@Const/work-registration-forms'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import createWizardFlow from '@App/stores/wizardFlow/create-wizard-flow'

const CreateWorkByWizardLayout = () => {
    const { workStore, wizardFlowStore } = useContext(StoresContext)

    useEffect(() => {
        analyticsSendPage('rightsholder_registration_new_work_wizard')

        return () => {
            workStore.setWorkDraftToLocal(CLEAR_WORK_DRAFT)
            workStore.setWizardStepValidation(false)
            wizardFlowStore.resetIndex()
        }
    }, [])

    wizardFlowStore.setFlow(createWizardFlow(wizardFlowStore))

    return <WizardFlow heading="Register Work" />
}

export default CreateWorkByWizardLayout
